module.exports = {
  CONST__CH_1: '1',
  CONST__CH_2: '2'
};
